import { MutationTree } from "vuex";
import {
  FridgeDetailsState,
  FridgeDetailsEconaviInfo,
  FridgeDetailsDoorOpenInfo,
  FridgeDetailsPushSettings,
  FridgeDetailsReductionAmountList,
  FridgeDetailsSetSettingsList,
  FridgeDetailsSettingsList,
  FridgeDetailsFunctionList,
  FridgeDetailsMylist,
  FridgeDetailsCoolingAssistSettingList,
  FridgeDetailsDisplayDescriptionList,
  FridgeDetailsSettingsInitialList
} from "@/types/fridgeDetails";
import NativeClient from "@/client/native-client";

const mutations: MutationTree<FridgeDetailsState> = {
  updateEconaviInfo: (state, result: FridgeDetailsEconaviInfo | null) => {
    state.econaviInfo = result;
  },
  updateDoorOpenInfo: (state, info: FridgeDetailsDoorOpenInfo | null) => {
    state.doorOpenInfo = info;
  },
  updatePushSettings: (state, info: FridgeDetailsPushSettings | null) => {
    state.pushSettings = info;
  },
  updateReductionInfo: (state, info: FridgeDetailsReductionAmountList | null) => {
    state.reductoinInfo = info;
  },
  updateSettings: (state, info: FridgeDetailsSettingsList | null) => {
    state.settings = info;
  },
  updateResultSettings: (state, info:  FridgeDetailsSettingsList | null) => {
    if (info == null) {
      return;
    }
    if (state.settings == null) {
      state.settings = info;
      return;
    }
    if (info.appliance_id != undefined && info.appliance_id != null) {
      state.settings.appliance_id = info.appliance_id;
    }
    if (info.partial_mode != undefined && info.partial_mode != null) {
      state.settings.partial_mode = info.partial_mode;
    }
    if (info.partial_freezing_room_mode != undefined && info.partial_freezing_room_mode != null) {
      state.settings.partial_freezing_room_mode = info.partial_freezing_room_mode;
    }
    if (info.cold_room_mode != undefined && info.cold_room_mode != null) {
      state.settings.cold_room_mode = info.cold_room_mode;
    }
    if (info.freezing_room_mode != undefined && info.freezing_room_mode != null) {
      state.settings.freezing_room_mode = info.freezing_room_mode;
    }
    if (info.fast_ice_status != undefined && info.fast_ice_status != null) {
      state.settings.fast_ice_status = info.fast_ice_status;
    }
    if (info.stop_ice_status != undefined && info.stop_ice_status != null) {
      state.settings.stop_ice_status = info.stop_ice_status;
    }
    if (info.econavi_lamp_status != undefined && info.econavi_lamp_status != null) {
      state.settings.econavi_lamp_status = info.econavi_lamp_status;
    }
    if (info.cooloven_lamp_mode != undefined && info.cooloven_lamp_mode != null) {
      state.settings.cooloven_lamp_mode = info.cooloven_lamp_mode;
    }
    if (info.door_alarms_mode != undefined && info.door_alarms_mode != null) {
      state.settings.door_alarms_mode = info.door_alarms_mode;
    }
    if (info.coldroom_light_mode != undefined && info.coldroom_light_mode != null) {
      state.settings.coldroom_light_mode = info.coldroom_light_mode;
    }
    if (info.pcroom_light_mode != undefined && info.pcroom_light_mode != null) {
      state.settings.pcroom_light_mode = info.pcroom_light_mode;
    }
    if (info.quick_button_setting_list != undefined && info.quick_button_setting_list != null) {
      state.settings.quick_button_setting_list = info.quick_button_setting_list;
    }
    if (info.fresh_frozen_status != undefined && info.fresh_frozen_status != null) {
      state.settings.fresh_frozen_status = info.fresh_frozen_status;
    }
    if (info.outage_prepare_status != undefined && info.outage_prepare_status != null) {
      state.settings.outage_prepare_status = info.outage_prepare_status;
    }
    if (info.partial_half_defrost_mode != undefined && info.partial_half_defrost_mode != null) {
      state.settings.partial_half_defrost_mode = info.partial_half_defrost_mode;
    }
  },
  updateOperationSettings: (state, info: FridgeDetailsSettingsList | null) => {
    state.operationSettings = info;
  },
  updateFunctionList: (state, info: FridgeDetailsFunctionList | null) => {
    state.functionList = info;
  },
  updateSettingsBuffer: (state, info: FridgeDetailsSetSettingsList | null) => {
    state.settingsBuffer = info;
  },
  updatePushSettingsBuffer: (state, info: FridgeDetailsPushSettings | null) => {
    state.pushSettingsBuffer = info;
  },
  updateCoolingAssistTopTab: (state, info: number | null) => {
    state.coolingAssisttopTabIdex = info;
  },
  updateMyAssist: (state, info: FridgeDetailsMylist | null) => {
    state.myAssist = info;
  },
  updateCoolingAssistSettings: (state, info: FridgeDetailsCoolingAssistSettingList | null) => {
    state.coolingAssisySettings = info;
  },
  updateDoorMonitorTabIndex: (state, index: number | null) => {
    NativeClient.sendDebugLog("mutation.ts updateDoorMonitorTabIndex() index = " + index);
    state.doorMonitorTabIndex = index;
  },
  updateDoorMonitorDailyTabIndex: (state, index: number | null) => {
    NativeClient.sendDebugLog("mutation.ts updateDoorMonitorDailyTabIndex() start index = " + index);
    state.doorMonitorDailyTabIndex = index;
  },
  updateDisplayDescriptionList:(state, info: FridgeDetailsDisplayDescriptionList | null) => {
    state.descriptionList = info;
  },
  updateSettingsInitialValue: (state, info: FridgeDetailsSettingsInitialList | null) => {
    const result = new FridgeDetailsSetSettingsList();
    if (info != null) {
      result.partial_mode = info!.partial_mode;
      result.partial_freezing_room_mode = info!.partial_freezing_room_mode;
      result.cold_room_mode = info!.cold_room_mode;
      result.freezing_room_mode = info!.freezing_room_mode;
      result.fast_ice_status = info!.fast_ice_status == "true" ? true : false;
      result.stop_ice_status = info!.stop_ice_status == "true" ? true : false;
      result.econavi_lamp_status = info!.econavi_lamp_status == undefined ? undefined : (info!.econavi_lamp_status == "true" ? true : false);
      result.cooloven_lamp_mode = info!.cooloven_lamp_mode;
      result.door_alarms_mode = info!.door_alarms_mode;
      result.coldroom_light_mode = info!.coldroom_light_mode;
      result.pcroom_light_mode = info!.pcroom_light_mode; 
      result.cooloven_mode = info!.cooloven_mode;
      result.cooloven_time = info!.cooloven_time;
      result.cooloven_second = info.cooloven_second;
      result.quick_button_setting_list = info!.quick_button_setting_list;
      result.fresh_frozen_status = info!.fresh_frozen_status == undefined ? undefined : (info!.fresh_frozen_status == "true" ? true : false);
      result.partial_half_defrost_mode = info!.partial_half_defrost_mode;
      result.sc_room_temperature = info!.sc_room_temperature;
      state.settingsInitialValue = result;
    } else {
      state.settingsInitialValue = null;
    }
  }
};

export default mutations;
